<template>
  <div>
    <div id="Chart3" style="width: 100%; height: 250px"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    myEcharts3() {
      var myChart3 = this.$echarts.init(document.getElementById("Chart3"));
      //配置图表
      var option3 = {
        grid: {
          containLabel: true,
          left: 0,
          right: 0,
          bottom: 20,
          top:30,
        },
        xAxis: {
          axisTick: {
            show: false,
            lineStyle: {
              width: "122",
            },
          },
          axisLine: {
            lineStyle: {
              color: "#ededed",
            },
          },

          data: ["2016", "2017", "2018", "2019","2020","2021","2022"],
          axisLabel: {
            formatter: function (value) {
              return `{a|${value}}`;
            },
            rich:{
              a:{
                color:"#666666"
              }
            }
          },

        },
        yAxis: {
          type: "value",
          show: false,
        },
        series: [
          {
            name: "格力电器",
            type: "bar",
            barGap: "100%",
            data: [26.16,-8.71,9.61,27.1,28.1, 9.12, -19.81],
            color: "#539cff",
            barWidth: 24,
            label: {
              formatter: "{c}%",
              show: true,
              position: "top",
              color: "#539cff",
            },
          },
          {
            name: "白色家电",
            type: "bar",
            barGap: "100%",
            data: [18.91,-3.21, 11.23,23.15,24.01, 25.93, -17.51],
            color: "#fcad2a",
            barWidth: 24,
          },
        ],
      };
      myChart3.setOption(option3);
    },
  },
  mounted() {
    this.myEcharts3();
  },
};
</script>

<style scoped>

</style>